import { BaseService } from '@/core/base-service';
import axios from 'axios';

export default class StakeholderGroupService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/stakeholder-group');
  }

  public getOptions(): Promise<any> {
    return axios.get(this.endpointName + '/combobox');
  }
}
